import { HeaderMenu } from 'types';

export const CareerVacancyLink = 'https://careers.kaspersky.ru/vacancy?page=0';

export const headerMenuItems: HeaderMenu[] = [
    { path: '#directions', title: 'Направления', dataAtSelector: 'headerRegistrationLink' },
    { path: '#calendar', title: 'Календарь', dataAtSelector: 'headerCallOfPapersLink' },
    // { path: '#reviews', title: 'Отзывы', dataAtSelector: 'headerSponsorsLink' },
    {
        path: 'https://careers.kaspersky.ru/about',
        title: 'О компании',
        dataAtSelector: 'headerAboutCompanyLink',
        externalLink: true,
    },
    { path: '#FAQ', title: 'FAQ', dataAtSelector: 'headerCodeLink' },
];

export const headerMenuItemsServiceDesc: HeaderMenu[] = [
    { path: '#calendar', title: 'Календарь', dataAtSelector: 'headerCallOfPapersLink' },
    { path: '#FAQ', title: 'FAQ', dataAtSelector: 'headerCodeLink' },
];

export const headerMenuItemsClosed: HeaderMenu[] = [
    {
        path: CareerVacancyLink,
        title: 'Вакансии',
        dataAtSelector: 'vacanciesLink',
        externalLink: true,
    },
    {
        path: 'https://careers.kaspersky.ru/about',
        title: 'О компании',
        dataAtSelector: 'headerAboutCompanyLink',
        externalLink: true,
    },
];
